export default __webpack_public_path__ + "static/media/0024.a4e31a67.WAV";